import { useQuery } from '@tanstack/react-query'
import { getProductReviewSummary } from '../services'

export function useReviewsSumary(productId: number) {
  const {
    data: reviewSummary,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['PRODUCT_REVIEW', { productId }],
    queryFn: () => getProductReviewSummary(productId),
    enabled: !!productId,
    staleTime: 60 * 1000,
  })
  return { reviewSummary, isLoading, error }
}
